<div class="home">
  <div class="home-box">
    <h3 class="title">{{ "home.title" | translate }}</h3>

    <h4 class="subtitle">{{ "home.subtitle" | translate }}</h4>
    <p>{{ "home.text" | translate }}</p>

    <div class="home-box-col">
      <div class="home-box-content">
        <b>{{ "home.intro.import" | translate }}</b>
        <a routerLink="/import" class="btn btn-primary text-uppercase w-100"
          ><i class="bi bi-upload"></i>
          {{ "home.cta.importPage" | translate }}</a
        >
      </div>
      <div class="home-box-content">
        <b>{{ "home.intro.monitoring" | translate }}</b>
        <a
          routerLink="/monitoring"
          class="btn btn-secondary text-uppercase w-100"
          ><i class="bi bi-table"></i>
          {{ "home.cta.monitoringPage" | translate }}</a
        >
      </div>
    </div>
  </div>
</div>
